module.exports = __webpack_public_path__ + "img/flowLogo.28d92f69.png";